import { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Loader } from 'shared-components';
import githubAuthService from 'services/githubAuth';
import { Path } from 'router/constant';
import { setIsGithubUser } from 'redux-setup/slices/userSlice';
import { useAppDispatch } from 'hooks/reduxHooks';
import { toast } from 'react-toastify';

export const GithubAuthLoading = () => {
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const code = searchParams.get('code');
  const githubLoginState = searchParams.get('state');
  const localGithubLoginState = localStorage.getItem('github_login_state');
  const isStateValid = githubLoginState === localGithubLoginState;
  const dispatch = useAppDispatch();

  const createUserAccessToken = async () => {
    try {
      const response = await githubAuthService.createGithubUser({
        Code: code ?? '',
      });
      if (response.status === 200) {
        setLoading(false);
        dispatch(setIsGithubUser(true));
        navigate(Path.SETTINGS);
        toast.success('Authenticated with GitHub');
      }
      if (response.status !== 200) {
        setLoading(false);
        navigate(Path.SETTINGS);
        toast.error('Failed to authenticate with GitHub');
      }
    } catch (error) {
      setLoading(false);
      navigate(Path.SETTINGS);
      toast.error('Failed to authenticate with GitHub');
    }
  };

  useEffect(() => {
    if (code && isStateValid) {
      createUserAccessToken();
    }
    if (!isStateValid) {
      localStorage.removeItem('github_login_state');
      dispatch(setIsGithubUser(false));

      navigate(Path.SETTINGS);
      toast.error('Failed to authenticate with GitHub - Invalid request');
    }
  }, [code, isStateValid]);
  return <Loader loading={loading} />;
};
